const CATEGORY_GROUPS = {
  SAFETY_FEATURE_CATEGORIES: 'safetyFeatureCategories',
  TEST_CATEGORIES: 'testCategories',
} as const;

export default CATEGORY_GROUPS;
